import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mainView" }
const _hoisted_2 = { class: "flex-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!
  const _component_introduction_component = _resolveComponent("introduction-component")!
  const _component_about_me_in_code_component = _resolveComponent("about-me-in-code-component")!
  const _component_projects_component = _resolveComponent("projects-component")!
  const _component_work_experience_component = _resolveComponent("work-experience-component")!
  const _component_contact_component = _resolveComponent("contact-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.atTheTop && _ctx.notMobile)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          id: "backToTop",
          src: "/UpArrow.svg",
          alt: "^",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_LanguageSwitcher, { id: "langSwitch" }),
    _createVNode(_component_introduction_component),
    _createVNode(_component_about_me_in_code_component),
    _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_projects_component, { class: "flex-child projects1" }),
      _createVNode(_component_work_experience_component, { class: "flex-child projects2" })
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
    _createVNode(_component_contact_component),
    _cache[1] || (
      _setBlockTracking(-1, true),
      (_cache[1] = _createElementVNode("p", { id: "copyright" }, [
        _cache[2] || (_cache[2] = _createTextVNode("Copyright (c) Nigel Christiaans 2023-2025"))
      ])).cacheIndex = 1,
      _setBlockTracking(1),
      _cache[1]
    )
  ]))
}